import React, { Component } from 'react';
import ReactExport from 'react-data-export';
import { Button } from '@progress/kendo-react-buttons';
import moment from 'moment';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class DeliveryTrackerExcel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            deliveryTrackerData: null,
            nullData: [{ columns: [], data: [] }],
        };
    }

    componentDidMount() {
        if (this.props.updateData === true) {
            this.populateDeliveryTrackerData();
        }
    }

    componentDidUpdate = async() => {
        if (this.props.updateData === true) {
            this.props.dataUpdated();
            await this.populateDeliveryTrackerData();
            document.getElementById("deliveryTrackerExcel").click();
        }
    }

    populateDeliveryTrackerData = async() => {
        let deliveryTrackerData = [];
        const borderStyle = {
            border: {
                top: { style: "thin", color: "000000" },
                right: { style: "thin", color: "000000" },
                bottom: { style: "thin", color: "000000" },
                left: { style: "thin", color: "000000" }
            }
        };

        if (this.props.deliveryTrackerData.DeliveryTrackerRecords && this.props.deliveryTrackerData.DeliveryTrackerRecords.length > 0) {            
            for (const record of this.props.deliveryTrackerData.DeliveryTrackerRecords) {
                deliveryTrackerData.push([
                    {
                        value: record.ProjectRegion ? record.ProjectRegion : '',
                        style: borderStyle
                    },
                    {
                        value: record.Customer ? record.Customer : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectName ? record.ProjectName : '',
                        style: borderStyle
                    },
                    {
                        value: record.OPID ? record.OPID : '',
                        style: borderStyle
                    },
                    {
                        value: record.Resource ? record.Resource : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectRole ? record.ProjectRole : '',
                        style: borderStyle
                    },
                    {
                        value: record.InvoicedEffortPct ? record.InvoicedEffortPct :0,
                        style: borderStyle
                    },
                    {
                        value: record.InvoicedEffort ? record.InvoicedEffort :0,
                        style: borderStyle
                    },
                    {
                        value: record.InvoicedRevenuePC ? record.InvoicedRevenuePC : 0,
                        style: borderStyle
                    },
                    {
                        value: record.InvoicedRevenueUSD ? record.InvoicedRevenueUSD : 0,
                        style: borderStyle
                    },
                    {
                        value: record.TimesheetEffortPct ? record.TimesheetEffortPct :0,
                        style: borderStyle
                    },
                    {
                        value: record.TimesheetEffort ? record.TimesheetEffort :0,
                        style: borderStyle
                    },
                    {
                        value: record.TimesheetRevenuePC ? record.TimesheetRevenuePC : 0,
                        style: borderStyle
                    },
                    {
                        value: record.TimesheetRevenueUSD ? record.TimesheetRevenueUSD : 0,
                        style: borderStyle
                    },
                    {
                        value: record.PlannedEffortPct ? record.PlannedEffortPct :0,
                        style: borderStyle
                    },
                    {
                        value: record.PlannedEffort ? record.PlannedEffort :0,
                        style: borderStyle
                    },
                    {
                        value: record.PlannedRevenuePC ? record.PlannedRevenuePC : 0,
                        style: borderStyle
                    },
                    {
                        value: record.PlannedRevenueUSD ? record.PlannedRevenueUSD : 0,
                        style: borderStyle
                    },
                    {
                        value: record.DailyRateRegion ? record.DailyRateRegion : 0,
                        style: borderStyle
                    },
                    {
                        value: record.DailyRateUSD ? record.DailyRateUSD : 0,
                        style: borderStyle
                    },
                    {
                        value: record.BillingMethod ? record.BillingMethod : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectDepartment ? record.ProjectDepartment : '',
                        style: borderStyle
                    },
                    {
                        value: record.EngagementType ? record.EngagementType : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectManager ? record.ProjectManager : '',
                        style: borderStyle
                    },
                    {
                        value: record.ResPractice ? record.ResPractice : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectStatus ? record.ProjectStatus : '',
                        style: borderStyle
                    }
                ])
            }

            deliveryTrackerData.push([
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                {
                    value: this.props.deliveryTrackerData.InvoicedTotalEffort ? Number(Number(this.props.deliveryTrackerData.InvoicedTotalEffort).toFixed(2)) : '',
                    style: {font: {bold: true} }
                },
                {
                    value: this.props.deliveryTrackerData.InvoicedRevenueTotalPC ? Number(Number(this.props.deliveryTrackerData.InvoicedRevenueTotalPC).toFixed(2)) : '',
                    style: {font: {bold: true} }
                },
                {
                    value: this.props.deliveryTrackerData.InvoicedRevenueTotalUSD ? Number(Number(this.props.deliveryTrackerData.InvoicedRevenueTotalUSD).toFixed(2)) : '',
                    style: {font: {bold: true} }
                },
                { value: '' },
                {
                    value: this.props.deliveryTrackerData.TimesheetTotalEffort ? Number(Number(this.props.deliveryTrackerData.TimesheetTotalEffort).toFixed(2)) : '',
                    style: {font: {bold: true} }
                },
                {
                    value: this.props.deliveryTrackerData.TimesheetRevenueTotalPC ? Number(Number(this.props.deliveryTrackerData.TimesheetRevenueTotalPC).toFixed(2)) : '',
                    style: {font: {bold: true} }
                },
                {
                    value: this.props.deliveryTrackerData.TimesheetRevenueTotalUSD ? Number(Number(this.props.deliveryTrackerData.TimesheetRevenueTotalUSD).toFixed(2)) : '',
                    style: {font: {bold: true} }
                },
                { value: '' },
                {
                    value: this.props.deliveryTrackerData.PlannedTotalEffort ? Number(Number(this.props.deliveryTrackerData.PlannedTotalEffort).toFixed(2)) : '',
                    style: {font: {bold: true} }
                },
                {
                    value: this.props.deliveryTrackerData.PlannedRevenueTotalPC ? Number(Number(this.props.deliveryTrackerData.PlannedRevenueTotalPC).toFixed(2)) : '',
                    style: {font: {bold: true} }
                },
                {
                    value: this.props.deliveryTrackerData.PlannedRevenueTotalUSD ? Number(Number(this.props.deliveryTrackerData.PlannedRevenueTotalUSD).toFixed(2)) : '',
                    style: {font: {bold: true} }
                },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' }
            ]);

            let headerColumns = [
                { value: 'Region',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Customer',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project Name',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'OPID',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Resource',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project Role',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Invoiced Effort %',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Invoiced Effort Days',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Invoiced Revenue (Project Currency)',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Invoiced Revenue (USD)',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Timesheet Effort %',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Timesheet Effort Days',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Timesheet Revenue (Project Currency)',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Timesheet Revenue (USD)',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Allocation Effort %',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Allocation Effort Days',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Allocation Revenue (Project Currency)',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Allocation Revenue (USD)',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Daily Rate (Project Currency)',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Daily Rate (USD)',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Billing Method',  style: {font: { bold: true }, border: borderStyle.border}},               
                { value: 'Project Department',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Engagement Type',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project Manager',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Resource Practice',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project Status',  style: {font: { bold: true }, border: borderStyle.border}},
            ];

            let emptyRow = [];
            for (const row of headerColumns) {
                if (row.value === 'OPID' || row.value === 'Project Status' || row.value === 'Daily Rate (Project Currency)' || row.value === 'Daily Rate (USD)' || 
                    row.value === 'Region' || row.value === 'Invoiced Effort Days' || row.value === 'Timesheet Effort Days' || row.value === 'Allocation Effort Days' ||
                    row.value === 'Invoiced Effort %' || row.value === 'Timesheet Effort %' || row.value === 'Allocation Effort %') {
                    let record = { title: '', width: { wpx: 100 } }
                    emptyRow.push(record);    
                } else {
                    let record = { title: '', width: { wpx: 150 } }
                    emptyRow.push(record);    
                }
            }

            let reportHeading = [];
            reportHeading.push(
                [
                    {
                        value: 'Date Range: ',
                        style: {font: { bold: true}}
                    },
                    { value: `${this.props.StartDate} to ${this.props.EndDate}` },
                ],
                [
                    {
                        value: 'Report Date: ',
                        style: {font: { bold: true}}
                    },
                    { value: this.props.reportDate },                ]
            );
    
            const deliveryTrackerDataGrid = [
                {
                    columns: [
                        {title: '', width: {wpx: 150}},
                        {title: '', width: {wpx: 150}},
                    ],
                    data: reportHeading
                },
                {
                    columns: emptyRow,
                    data: [headerColumns, ...deliveryTrackerData]
                }
            ];
    
            await this.setState({
                deliveryTrackerDataGrid: deliveryTrackerDataGrid
            });
        }
    }

    render() {
        return (
            <ExcelFile
                filename={'Delivery Tracker - ' + moment(new Date()).format('DD-MMM-YYYY')}
                element={ 
                    <Button id={"deliveryTrackerExcel"} className="d-none">
                        {''}
                    </Button>
                }
            >
                <ExcelSheet
                    dataSet={this.state.deliveryTrackerDataGrid ? this.state.deliveryTrackerDataGrid : this.state.nullData}
                    name="Delivery Tracker"
                />
            </ExcelFile>
        );
    }
}

export default DeliveryTrackerExcel;
